import { priceListService } from '../services'

import Vue from 'vue'

const state = {
  all: {
    filterInitialized: false,
    loading: true,
    items: [],
    filter: {},
    meta: {}
  }
}

const actions = {
  getByCustomerId ({ commit }, customerId) {
    return priceListService.getByCustomerId(customerId)
      .then(data => {
        commit('getByCustomerIdSuccess', data.result)
        return data.result
      })
      .catch(error => {
        commit('getByCustomerIdFailure', error)
      })
  },

  getByProjectCode ({ commit }, projectCode) {
    return priceListService.getByProjectCode(projectCode)
      .then(data => {
        commit('getByProjectCodeSuccess', data.result)
        return data.result
      })
      .catch(error => {
        commit('getByProjectCodeFailure', error)
      })
  }
}

const mutations = {
  getByCustomerIdSuccess (state, data) {
    state.all.items = data.items
    state.all.loading = false
  },
  getByCustomerIdFailure (state, error) {
    state.all.error = error
    state.all.loading = false
    Vue.$toast('Kunde inte hämta priser', 'error')
  },

  getByProjectCodeSuccess (state, data) {
    state.all.items = data.items
    state.all.loading = false
  },
  getByProjectCodeFailure (state, error) {
    state.all.error = error
    state.all.loading = false
    Vue.$toast('Kunde inte hämta priser', 'error')
  }
}

export const priceList = {
  namespaced: true,
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/price-list.module.js